import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/Login'
import My from '@/views/My'
import UserEdit from '@/views/user_edit'
import Exercise from '@/views/Exercise'
import Subject from '@/views/Subject'
import CommonProblem from '@/views/CommonProblem'
import Buy from '@/views/Buy'
import Topics from '@/views/Topics'
import Courses from '@/views/Courses'
// import CourseDetails from '@/views/course_details'
import CourseDetailsTx from '@/views/course_details_tx'
import Learns from '@/views/Learns'
import CdKey from '@/views/CdKey'
import Share from '@/views/Share'
import Vip from '@/views/Vip'
import my_orders from '@/views/my_orders'

import OrganUsers from '@/views/organ/Users.vue'
import OrganOrders from '@/views/organ/Orders.vue'
import OrganMangers from '@/views/organ/Mangers.vue'
import OrganOrgan from '@/views/organ/Organ.vue'
import OrganOrgans from '@/views/organ/Organs.vue'
import OrganAgentStatistics from '@/views/organ/AgentStatistics.vue'
import OrganChangeSubject from '@/views/organ/ChangeSubject.vue'
import OrganCreateCdKey from '@/views/organ/CreateCdKey.vue'
import OrganPayConfirm from '@/views/organ/PayConfirm.vue'

import ClassJoin from "@/views/ClassJoin.vue";
import register from '@/views/register.vue'
import registerInfo from '@/views/register_info.vue'

Vue.use(Router);

const routes = [
    {path: '/', name: '首页', component: Home},
    {path: '/index.html', name: '首页', component: Home},
    {path: '/index', name: '首页', component: Home},
    {path: '/login', name: '登陆', component: Login},
    {path: '/my', name: '个人中心', component: My},
    {path: '/user/edit', name: '完善个人信息', component: UserEdit},
    {path: '/exercise', name: '练习', component: Exercise},
    {path: '/subject', name: '选择科目', component: Subject},
    {path: '/common_problem', name: '常见问题', component: CommonProblem},
    {path: '/buy', name: '科目充值', component: Buy},
    {path: '/topics', name: '试题搜索', component: Topics},
    {path: '/courses', name: '课程学习', component: Courses},
    // {path: '/course/details', name: '课程学习', component: CourseDetails},
    {path: '/course/details', name: '课程学习', component: CourseDetailsTx},
    {path: '/learns', name: '学习记录', component: Learns},
    {path: '/cd_key', name: '充值卡', component: CdKey},
    {path: '/vip', name: '充值科目', component: Vip},
    {path: '/share', name: '我要分享', component: Share},
    {path: '/my/orders', name: '订单列表', component: my_orders},
    {path: '/organ/users', name: '我的学员', component: OrganUsers},
    {path: '/organ/orders', name: '学员充值情况', component: OrganOrders},
    {path: '/organ/mangers', name: '机构管理员', component: OrganMangers},
    {path: '/admin/agent_statistics', name: '代理统计', component: OrganAgentStatistics},
    {path: '/admin/change_subject', name: '更改用户充值科目', component: OrganChangeSubject},
    {path: '/admin/create_cd_key', name: '生成充值号', component: OrganCreateCdKey},
    {path: '/admin/organ', name: '设置/修改合作伙伴', component: OrganOrgan},
    {path: '/organs', name: '合作伙伴列表', component: OrganOrgans},
    {path: '/admin/pay_confirm', name: '人工确认用户充值', component: OrganPayConfirm},
    {path: '/class/join', name: '加入班级', component: ClassJoin},

    {path: '/register', name: '在线报名', component: register},
    {path: '/register_info', name: '在线报名', component: registerInfo},
];


const router = new Router({
    mode: 'history',
    routes: routes
});

export default router
